const scrollTop = () => {
    if(window.location.href.indexOf('#') === -1) {
        window.scrollTo(0, 0);
    }
};

export { scrollTop };